
interface JobTabsProps {
    jobId: number;
    siteAddress: string;
    tab: string;
    tabChanged(url: string): void;
}

const JobTabsData = (props: JobTabsProps) => {

    const tabSelected = (tab: string) => {
        //redirect to new tab location
        var url = "/job/" + props.jobId + "/" + tab;
        props.tabChanged(url);
    }

    const tabChanged = (e: any) => {
        tabSelected(e.target.value);
    }

    const noChange = (e: any) => {
        e.preventDefault();
        //no changes as user doesn't actually click on the radio button
    }

    return (
        <div className="marginBottom10">
            <h1>{props.jobId} - {props.siteAddress}</h1>
            <div className="tabsComponent" id="tab-container">
                <div className="tabsComponent__showDropdown">
                    <label className="input-group" htmlFor="jobTab">
                        <span className="label">Item Type</span>
                        <select className="select" id="jobTab" value={props.tab} onChange={tabChanged} >
                            <option value="details">Details</option>
                            <option value="quote">Quote</option>
                            <option value="schedule">Schedule</option>
                            <option value="photos">Photos</option>
                            <option value="files">Files</option>
                            <option value="invoices">Invoices</option>
                            <option value="notes">Notes</option>
                        </select>
                    </label>
                </div>
                <div className="tabsComponent__tabs tabsComponent__hideTabs">
                    <input type="radio" name="tabs" id="tab1" className="tabsComponent__control" checked={props.tab == 'details'} onChange={(e) => noChange(e)}></input>
                    <label className="tabsComponent__label" htmlFor="tabItem" onClick={() => tabSelected('details')}>Details</label>

                    <input type="radio" name="tabs" id="tab2" className="tabsComponent__control" checked={props.tab == 'quote'} onChange={(e) => noChange(e)}></input>
                    <label className="tabsComponent__label" htmlFor="tabItem" onClick={() => tabSelected('quote')}>Quote</label>

                    <input type="radio" name="tabs" id="tab3" className="tabsComponent__control" checked={props.tab == 'schedule'} onChange={(e) => noChange(e)}></input>
                    <label className="tabsComponent__label" htmlFor="tabItem" onClick={() => tabSelected('schedule')}>Schedule</label>

                    <input type="radio" name="tabs" id="tab4" className="tabsComponent__control" checked={props.tab == 'photos'} onChange={(e) => noChange(e)}></input>
                    <label className="tabsComponent__label" htmlFor="tabItem" onClick={() => tabSelected('photos')}>Photos</label>

                    <input type="radio" name="tabs" id="tab5" className="tabsComponent__control" checked={props.tab == 'files'} onChange={(e) => noChange(e)}></input>
                    <label className="tabsComponent__label" htmlFor="tabItem" onClick={() => tabSelected('files')}>Files</label>

                    <input type="radio" name="tabs" id="tab6" className="tabsComponent__control" checked={props.tab == 'invoices'} onChange={(e) => noChange(e)}></input>
                    <label className="tabsComponent__label" htmlFor="tabItem" onClick={() => tabSelected('invoices')}>Invoices</label>

                    <input type="radio" name="tabs" id="tab7" className="tabsComponent__control" checked={props.tab == 'notes'} onChange={(e) => noChange(e)}></input>
                    <label className="tabsComponent__label" htmlFor="tabItem" onClick={() => tabSelected('notes')}>Notes</label>
                </div>

            </div>

        </div>
    );

}

export default JobTabsData;